import { customElement, property, state } from "lit/decorators.js";

import { css, html, nothing, TemplateResult } from "lit";
import { consume } from "@lit/context";
import { IFilterContext, filterContext } from "./filterContext";
import { LitElementBase } from "../LitElementBase";

@customElement("ehm-filter-active")
export class FilterActive extends LitElementBase {
  static styles = css`
    slot {
      display: block;
      margin: 1.5rem 0 2rem;
    }
    .filters {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    .title {
      display: block;
    }
    button {
      display: flex;
      align-items: center;
      appearance: none;
      background: var(--button-primary-bg);
      color: var(--button-primary-fg);
      font: var(--font-text-sm);
      border: none;
      border-radius: 100px;
      height: 2.25rem;
      padding: 0 1rem;
      cursor: pointer;
      gap: .5rem;
      --icon-size: 1rem;
    }
    button:hover {
      background: var(--button-primary-bg_hover);
    }
    button:focus-visible {
      outline: var(--outline) !important;
      outline-offset: var(--outline-offset) !important;
    }
    @media (max-width: 450px) {
      slot {
        margin: 0.25rem 0 1rem
      }
    }
  `;

  @property({ attribute: "title" }) title = "";

  @state()
  @consume({ context: filterContext, subscribe: true })
  private context?: IFilterContext;

  constructor() {
    super();
    this.setAttribute("aria-live", "polite");
  }

  updated() {
    this.setAttribute("aria-loading", this.context?.isLoading ? "true" : "false");
  }

  protected render(): TemplateResult | typeof nothing {
    const activeFilters = this.context?.filters || [];

    if (activeFilters.length === 0) return nothing;

    const buttons = activeFilters.map((filter) => {
      return html`
        <li>
          <button @click=${() => this.context?.updateFilters(filter, "remove")}>
            ${filter.name}
            <ehm-icon name="cross"></ehm-icon>
          </button>
        </li>
      `;
    });

    return html`
      <slot>
        ${this.title
          ? html`<span class="title heading-3xs m">${this.title}</span>)`
          : nothing}
        <ul class="filters">
          ${buttons}
        </ul>
      </slot>
    `;
  }
}